<template>
  <div class="form-group" v-if="render">
    <label :title="tooltip(element.label)">
      {{ t(element.label) }}
      <icons-render :propIcons="element.icons"/>
    </label>
    <input ref="element" v-bind:checked="value ? 'checked' : ''" type="checkbox" style="display: none">
  </div>
</template>

<script>
import IconsRender from '../../templates/widgets/icons-render'
import DictionaryLoader         from '@/model/loader/dictionary-loader'

export default {
  name:       'Checkbox',
  components: {
    IconsRender
  },
  props:      {
    element: {
      required: true,
      type:     Object,
      default:  () => {
        return {
          name:     null,
          type:     null,
          dataType: null,
          label:    null
        }
      }
    }
  },
  data () {
    return {
      value:  0,
      render: true
    }
  },

  mounted () {
    setTimeout(() => {
      const module  = this
      const element = $(this.$refs.element)
      element.labelauty({ label: false })
      element.click(function () {
        if ($(this).is(':checked')) {
          module.value = 1
          module.$emit('changeValue', { element: module.element, value: module.value })
        }
        else {
          module.value = 0
          module.$emit('changeValue', { element: module.element, value: module.value })
        }
      })
    }, 50)
  },

  methods: {
    /**
     *
     * @param value
     */
    updateValue (value) {
      value = value.value

      this.value = value
    },

    setRender (render) {
      this.render = render
    },

    tooltip (key) {
      return DictionaryLoader.tooltip(key, this.$user.languageCode)
    }
  }
}
</script>

<style scoped>

</style>
